import { render } from "./dining.vue?vue&type=template&id=c57475fa&scoped=true"
import script from "./dining.vue?vue&type=script&lang=js"
export * from "./dining.vue?vue&type=script&lang=js"

import "./dining.vue?vue&type=style&index=0&id=c57475fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c57475fa"

export default script